<template>
  <va-modal v-model="showModal" hide-default-actions no-padding size="large" class="absolute w-full pt-24">
    <!-- <div class="flex flex-col"> -->
    <!-- <div class="p-4"> -->
    <VaCarousel
      v-model="currentSlide"
      :items="slides.map((s) => s.image)"
      class="max-w-full"
      :arrows="false"
      autoscroll
      indicators
      fit="contain"
    >
      <template #indicator="{ index }">
        <div
          class="h-4 w-4 rounded-full cursor-pointer"
          :class="{ 'bg-green-500': index === currentSlide, 'bg-gray-200': index !== currentSlide }"
        ></div>
      </template>
    </VaCarousel>
    <!-- </div> -->

    <template #footer>
      <div class="pt-4 px-4 text-left w-full text-wrap">
        <h3 class="text-3xl">{{ slides[currentSlide].title }}</h3>
        <p class="pt-2 max-w-[500px] text-gray-500">{{ slides[currentSlide].description }}</p>
      </div>

      <div class="flex justify-between p-4 gap-2">
        <va-button preset="secondary" @click="closeModal">Skip</va-button>
        <va-button @click="nextSlide">{{ isLastSlide ? 'Finish' : 'Next' }}</va-button>
      </div>
    </template>

    <!-- </div> -->
  </va-modal>
</template>

<script setup>
  import { ref, computed } from 'vue'
  import { VaCarousel } from 'vuestic-ui'

  const showModal = ref(true)
  const currentSlide = ref(0)

  const slides = ref([
    {
      image: '/images/business_partner_guides/bp_slide_1.png',
      title: 'Manage Your Drivers',
      description:
        'Effortlessly oversee your entire team from a single, intuitive dashboard. Access detailed driver profiles, monitor their real-time status, and review performance history to keep your operations running smoothly.',
    },
    {
      image: '/images/business_partner_guides/bp_slide_2.png',
      title: 'Your Ride List',
      description:
        'Stay organized with a comprehensive overview of all your bookings. You can easily filter rides by their status—such as pending, active, or completed—and manage each one individually for seamless control.',
    },
    {
      image: '/images/business_partner_guides/bp_slide_3.png',
      title: 'Create a New Ride',
      description:
        "Booking a new ride is quick and simple. Just input the pickup and drop-off locations, fill in the passenger's information, and add any other necessary details to dispatch a new ride in moments.",
    },
    {
      image: '/images/business_partner_guides/bp_slide_4.png',
      title: 'Ride Preview & Route',
      description:
        'Confirm all details before dispatch. Get a clear summary of the created ride, including an estimated route preview on the map, to ensure everything is perfect.',
    },
    {
      image: '/images/business_partner_guides/bp_slide_5.png',
      title: 'Assign or Delegate',
      description:
        'You have full flexibility in assigning rides. Either choose one of your own drivers or, for maximum convenience, complete the payment and delegate the entire trip to the Carriving network.',
    },
  ])

  const isLastSlide = computed(() => currentSlide.value === slides.value.length - 1)

  const emit = defineEmits(['close'])

  const closeModal = () => {
    showModal.value = false
    localStorage.setItem('businessGuidesPassed', 'true')
    emit('close')
  }

  const nextSlide = () => {
    if (isLastSlide.value) {
      closeModal()
    } else {
      currentSlide.value++
    }
  }
</script>

<style scoped>
  .va-modal {
    /* max-width: 600px; */
  }
</style>
